import { isProductionEnvironment } from "@remi/environment";

export const getLinkToQbInvoice = (externalId: string) =>
  isProductionEnvironment()
    ? `https://app.qbo.intuit.com/app/invoice?txnId=${externalId}`
    : `https://app.sandbox.qbo.intuit.com/app/invoice?txnId=${externalId}`;

export const getLinkToQbCreditMemo = (externalId: string) =>
  isProductionEnvironment()
    ? `https://app.qbo.intuit.com/app/creditmemo?txnId=${externalId}`
    : `https://app.sandbox.qbo.intuit.com/app/creditmemo?txnId=${externalId}`;

export const getLinkToQbBill = (externalId: string) =>
  isProductionEnvironment()
    ? `https://app.qbo.intuit.com/app/bill?txnId=${externalId}`
    : `https://app.sandbox.qbo.intuit.com/app/bill?txnId=${externalId}`;

export const getLinkToQbVendorCredit = (externalId: string) =>
  isProductionEnvironment()
    ? `https://app.qbo.intuit.com/app/vendorcredit?txnId=${externalId}`
    : `https://app.sandbox.qbo.intuit.com/app/vendorcredit?txnId=${externalId}`;

export const getLinkToQbJournalEntry = (externalId: string) =>
  isProductionEnvironment()
    ? `https://app.qbo.intuit.com/app/journal?txnId=${externalId}`
    : `https://app.sandbox.qbo.intuit.com/app/journal?txnId=${externalId}`;

export const getLinktoQbVendor = (externalId: string) =>
  isProductionEnvironment()
    ? `https://app.qbo.intuit.com/app/vendordetail?nameId=${externalId}`
    : `https://app.sandbox.qbo.intuit.com/app/vendordetail?nameId=${externalId}`;
